/* eslint-disable import/prefer-default-export */
import { createImageUrlBuilder } from '@sanity/image-url'
import getGlobals from './getGlobals'

export function imageUrlFor(source) {
  const imageBuilder = createImageUrlBuilder({
    projectId: getGlobals().SANITY_PROJECT_ID,
    dataset: getGlobals().SANITY_DATASET,
  })
  return imageBuilder.image(source)
}
